import {observable, action, runInAction} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {handleSeerchAndPage, ValueObjToObj,setStore} from "../../../../utils/Utils";
import moment from 'moment';
// moment.locale('zh-cn');


class EPCSparepartCatalogTechnologyStore {
    @observable pagination//分页
    @observable searchFields//从页面绑定到store
    @observable list//初始化数据
    @observable loading//数据加载
    @observable modalLoading//模态框数据加载
    @observable modal//模态款
    @observable maintainRow//点击维护时获取当行数据
    @observable initSelectData//回显时下拉框的数据
    @observable editTechnologyData//回显和保存的数据
    @observable techmologyModal   //维护模态框

    constructor() {
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.searchFields = {
            spareNameEn: '',
            materialNo: '',
            spareNo: '',
            customCode: '',
            commodityInspectionMark: '',
            CIQText: '',
            customsChineseName: '',
            isMaintain: '',
            spareName: '',

        }
        this.list=[]
        this.loading=false
        this.modalLoading=false
        this.modal=false
        this.maintainRow={}
        this.editTechnologyData = {}
        this.initSelectData = {
            netWeightList:{},
            regulationsList:{},
            sparePartTypeList:{},
            sparePartSourceList:{},
            sparePartStatusIdentifierList:{},
            dataSourcesList:{},
            purchasingChannelList:{},
            IndustryTypeList:{},
            materialTypeList:{},
            basicUnitOfMeasureList:{},
            commodityInspectionMarkList:{},
            productGroupList:{},
            materialGroupList:{},
        }
        this.techmologyModal=false
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***
     * 页面数据绑到store
     * @param changedFields
     */
    @action
    searchSpareAndCatalogBonding=(changedFields)=>{
        this.searchFields = {...this.searchFields,...ValueObjToObj(changedFields)}
    }

    /***
     * 维护页面数据绑到store
     * @param changedFields
     */
    @action
    onEditFieldChange=(changedFields)=>{
        this.editTechnologyData = {...this.editTechnologyData,...ValueObjToObj(changedFields)}
    }

    /***
     * 页面初始数据、查询
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initData= async (page)=>{
        this.loading=true
        if(this.searchFields.spareNameEn===undefined||this.searchFields.customCode===undefined||
            this.searchFields.commodityInspectionMark===undefined||this.searchFields.CIQText===undefined||
            this.searchFields.customsChineseName===undefined||this.searchFields.isMaintain===undefined){
            this.searchFields.spareNameEn=''
            this.searchFields.customCode=''
            this.searchFields.commodityInspectionMark=''
            this.searchFields.CIQText=''
            this.searchFields.customsChineseName=''
            this.searchFields.isMaintain=''
        }
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getListForPageByContent`,search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(()=>{
            this.list = res.content|| []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading=false
        })
    }

    /***
     * 重置清空
     */
    clearSearch=async()=>{
        this.searchFields = {
            spareNameEn: '',
            materialNo: '',
            spareNo: '',
            customCode: '',
            commodityInspectionMark: '',
            CIQText: '',
            customsChineseName: '',
            isMaintain: '',
            spareName: '',
        }
        await this.initData(1)
    }

    /***
     * 获取下拉框的数据
     * @param record
     * @returns {Promise<void>}
     */
    @action
    maintain = async (record) =>{
        this.modal=true
        this.loading=true
        this.modalLoading=true
        this.maintainRow = record
        let id = record.id
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getSelectValues`)
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/getBySpareNo/id/${id}`)
        runInAction(()=>{
            let entryTimeEnd = res1.entryTimeEnd?moment(res1.entryTimeEnd):null
            let entryTimeStart = res1.entryTimeStart?moment(res1.entryTimeStart):null
            this.initSelectData = {...this.initSelectData,...res}
            let sixPhotosList = res1.sixPhotosList&&res1.sixPhotosList.map((item,index)=> ({uid: index, url: item,}))
            this.editTechnologyData = {
                ...this.editTechnologyData,
                ...res1,
                time:[entryTimeStart,entryTimeEnd],
                sixPhotosList:sixPhotosList||[]
            }
            this.techmologyModal = true
            this.loading=false
            this.modalLoading=false
        })
    }

    /***
     * 保存技术属性
     * @returns {Promise<void>}
     */
    @action
    save=async()=>{
        let list = []
        Object.values(this.editTechnologyData.sixPhotosList).map(item=>{
            if(item.response){
              return  list.push(`https://`+item.response.split(':').pop())
            }else {
                return list.push(item.url)
            }
        })
        this.editTechnologyData.sixPhotos = list.length > 0 ? this.editTechnologyData.sixPhotos : ''
        this.editTechnologyData.id = this.maintainRow.id;
        this.editTechnologyData.entryTimeStart = this.editTechnologyData.time&&this.editTechnologyData.time[0]?this.editTechnologyData.time[0].format("YYYY-MM-DD"):'';
        this.editTechnologyData.entryTimeEnd = this.editTechnologyData.time&&this.editTechnologyData.time[1]?this.editTechnologyData.time[1].format("YYYY-MM-DD"):'';
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/sparePart/updateSparePart`,{
        ...this.editTechnologyData,
            sixPhotosList: list
        })
        await this.initData(this.pagination.current)
        runInAction(()=>{
            this.modal=false
        })
    }

    /**
     * 关闭模态框
     */
    @action
    showTechnologyModal = ()=>{
        this.techmologyModal=false
    }

}

export default new EPCSparepartCatalogTechnologyStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCSparepartCatalogTechnology/store.js